import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NaruceneKolicineService {

  constructor(private _http: HttpClient) { }

  dohvatiNaruceno(a: any) {
    return this._http.post(AppConfig.ipAddress + 'ukupne_narucene_kolicine', a)
      .pipe(map((res: any) => res));
  }

  dohvatiNabavljace(a: any) {
    return this._http.post(AppConfig.ipAddress + 'ukupna_narucena_kolicina_za_jedan_proizvod', a)
      .pipe(map((res: any) => res));
  }

  dohvatiProizvodZaPripremuPlana(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_proizvod_za_pripremu_plana', a)
      .pipe(map((res: any) => res));
  }

  spremiPlan(a: any) {
    return this._http.post(AppConfig.ipAddress + 'spremi_plan', a)
      .pipe(map((res: any) => res));
  }

  dohvatiDjelatnike(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_sve_djelatnike', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSmjeneSaPlanom(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_sve_smjene_koje_imaju_plan', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPlan(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_plan_za_datum_i_smjenu', a)
      .pipe(map((res: any) => res));
  }

  provjeraPaleta(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_polovicne_palete', a)
      .pipe(map((res: any) => res));
  }

  tjedanUGodini(a: any) {
    return this._http.post(AppConfig.ipAddress + 'tjedan_u_godini', a)
      .pipe(map((res: any) => res));
  }

}